import React from 'react';

const SmallArrowLeft = () => {
  return (
    <svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.6705 0.376577C9.10983 0.87868 9.10983 1.69275 8.6705 2.19485L2.71599 9L8.6705 15.8051C9.10983 16.3073 9.10983 17.1213 8.6705 17.6234C8.23116 18.1255 7.51884 18.1255 7.0795 17.6234L0.329505 9.90914C-0.109835 9.40703 -0.109835 8.59297 0.329505 8.09086L7.0795 0.376577C7.51884 -0.125526 8.23116 -0.125526 8.6705 0.376577Z"
        fill="#212121"
      />
    </svg>
  );
};

export { SmallArrowLeft };
